/* eslint-disable no-unused-vars */
import "../../assets/scss/taginput.css"; // If using WebPack and style-loader.
import React from "react";
import TagsInput from "react-tagsinput";

export default function PTagsInput(props) {
  return (
    <div>
      <TagsInput
        value={props.value}
        onChange={(e) => props.onChange(e)}
        inputProps={{
          className: "react-tagsinput-input",
          placeholder: props.placeHolder,
        }}
        onFocus={(e) => {
          if (props.onFocus) props.onFocus(e);
        }}
        onBlur={(e) => {
          if (props.onBlur) props.onBlur(e);
        }}
      />
      <div style={{ color: "#f44336", size: "0.75rem" }}>
        {props.errorMessage}
      </div>
    </div>
  );
}
